import { render } from "./CustomerReportPage.vue?vue&type=template&id=4f558679&scoped=true&ts=true"
import script from "./CustomerReportPage.vue?vue&type=script&lang=ts"
export * from "./CustomerReportPage.vue?vue&type=script&lang=ts"

import "./CustomerReportPage.vue?vue&type=style&index=0&id=4f558679&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f558679"]])

export default __exports__